<template>
  <div
    v-if="showCourseList"
    :class="{
      'h5-org-course-list': isH5,
      'pc-org-course-list': !isH5,
    }"
    class="org-course-list"
  >
    <!-- tab -->
    <div v-show="!inIosReview" class="type-list-wrap">
      <div
        ref="scrollContent"
        class="scroll-content"
        :class="{ 'have-dropdown': [0, 1, 2].includes(type) }"
      >
        <div class="type-list">
          <span
            :id="'tab-item-' + item.type"
            @click="handleTypeChange(item.type)"
            v-for="item in typeList"
            :key="item.type"
            :class="{ 'is-active': type === item.type }"
            class="type-item"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <el-dropdown
        v-show="[0, 1, 2].includes(type)"
        @command="handleMenuBehavior"
      >
        <span class="el-dropdown-link">
          排序<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="0">推荐排序</el-dropdown-item>
          <el-dropdown-item command="1">价格从低到高</el-dropdown-item>
          <el-dropdown-item command="2">价格从高到低</el-dropdown-item>
          <el-dropdown-item command="3">报名人数从少到多</el-dropdown-item>
          <el-dropdown-item command="4">报名人数从多到少</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 推荐列表 -->
    <div v-if="moduleInfo.moduleList && moduleInfo.moduleList.length">
      <recommend-course
        v-show="type === item.id"
        v-for="item in moduleInfo.moduleList"
        :key="item.id"
        :moduleInfo="item"
      />
    </div>

    <!-- 其他列表 -->
    <div v-show="[0, 1, 2].includes(type)">
      <div v-if="courseList && courseList.length">
        <div class="content-wrap double-column">
          <CourseCardOrg
            class="org-course-card"
            v-for="item in courseList"
            :key="item.id"
            :courseInfo="item"
            type="small"
          />
        </div>
        <!-- 查看更多 -->
        <div v-show="total > page_size" class="show-more">
          <p v-if="noMore">没有更多了~</p>
          <p v-else @click="showMore" class="have-more">
            查看更多<i class="el-icon-arrow-down"></i>
          </p>
        </div>
      </div>
      <el-empty
        v-else
        description="暂无内容"
        :image="require('@/assets/img/live-list/empty.png')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { getCourseList } from "@saas/service-api/src/course";
import RecommendCourse from "./RecommendCourse";
import { CourseCardOrg, isH5 } from "@saas/components/src";
export default {
  props: {
    moduleInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: function () {
    return {
      isH5: isH5(),
      typeList: [
        {
          type: 0,
          name: "全部",
        },
        {
          type: 1,
          name: "免费",
        },
        {
          type: 2,
          name: "收费",
        },
      ],
      type: 0,
      page_no: 1,
      order_by: 0,
      courseList: [],
      page_size: 10,
      noMore: false, //没有更多
      loading: false, //加载数据中
      inIosReview: false,
      total: 0,
      showCourseList: true, //是否展示课程列表
    };
  },
  created() {
    this.inIosReview = this.$route.query?.inReview === "1";
  },
  methods: {
    scrollActiveTab(id) {
      if (this.$refs.scrollContent) {
        let itemEle = document.getElementById(`tab-item-${id}`);
        let width = 280;
        if (this.isH5) {
          width = document.body.offsetWidth * 0.3;
        }
        if (itemEle?.offsetLeft > width) {
          if ([0, 1, 2].includes(id)) {
            setTimeout(() => {
              this.$refs.scrollContent.scrollLeft = 800;
            }, 200);
          } else {
            this.$refs.scrollContent.scrollLeft = itemEle.offsetLeft - width;
          }
        } else {
          this.$refs.scrollContent.scrollLeft = 0;
        }
      }
    },
    handleTypeChange(type) {
      this.type = type;
      // if (type !== 3) {
      //   this.page_no = 1;
      //   this.apiGetCourseList();
      // }
      // this.scrollActiveTab(type);
    },
    handleMenuBehavior(command) {
      this.page_no = 1;
      this.order_by = command;
      this.apiGetCourseList();
    },
    showMore() {
      this.page_no += 1;
      this.apiGetCourseList();
    },
    apiGetCourseList(type) {
      this.loading = true;
      let params = {
        page_no: this.page_no,
        page_size: this.page_size,
        org_id: this.$route.params.org_id,
        course_name: "",
        fee_type: this.type || "",
        order_by: Number(this.order_by) || "",
      };
      getCourseList(params)
        .then((res) => {
          if (res.code === 1) {
            if (res.data && res.data.list) {
              this.total = res.data?.total || 0;
              if (type === "initData" && this.total === 0) {
                // 机构下没有课程-不展示整个课程列表
                this.showCourseList = false;
              }
              if (params.page_no === 1) {
                this.courseList = res.data.list;
              } else {
                this.courseList = this.courseList.concat(res.data.list);
              }
              if (this.courseList.length === res.data.total) {
                this.noMore = true;
              } else {
                this.noMore = false;
              }
            }
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
  components: {
    CourseCardOrg,
    "recommend-course": RecommendCourse,
  },
  watch: {
    moduleInfo: {
      handler: function (newVal) {
        // 有推荐课程
        if (newVal?.moduleList?.length) {
          let arr = [];
          newVal.moduleList.forEach((item) => {
            if (item?.content_list?.length && item.content_list[0])
              arr.push({
                type: item.id,
                name: item.module_title,
              });
          });
          this.typeList = [
            ...arr,
            {
              type: 0,
              name: "全部",
            },
            {
              type: 1,
              name: "免费",
            },
            {
              type: 2,
              name: "收费",
            },
          ];
          this.type = this.typeList[0].type;
        } else {
          // 没有推荐课程--获取全部课程
          this.page_no = 1;
          this.apiGetCourseList("initData");
        }
      },
      immediate: true, // 设置为true，以便在初次渲染时执行handler
    },
    type: {
      handler: function (newVal) {
        if ([0, 1, 2].includes(newVal)) {
          this.page_no = 1;
          this.apiGetCourseList();
        }
        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollActiveTab(newVal);
          }, 200);
        });
      },
      immediate: true, // 设置为true，以便在初次渲染时执行handler
    },
  },
};
</script>

<style lang="scss" scoped>
.pc-org-course-list {
  .have-dropdown.scroll-content {
    width: calc(100% - 70px);
  }
  .scroll-content {
    width: 100%;
    scrollbar-width: 0;
    /* 标准语法，Firefox 支持 */
    -ms-overflow-style: none;
    /* IE 和 Edge */
    &::-webkit-scrollbar {
      display: none;
      /* WebKit 内核浏览器 */
    }
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-behavior: smooth;
  }
  .type-list {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: max-content;
  }
  .content-wrap > div:last-child {
    margin-bottom: 0;
  }
  .double-column {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    & > div:nth-last-child(2) {
      margin-bottom: 0;
    }
  }
  .show-more {
    margin-top: 20px;
    width: 100%;
    display: flex;
    justify-content: center;
    font-weight: 400;
    font-size: 12px;
    color: #515350;
    line-height: 17px;
    .have-more {
      color: #00c89d;
      padding: 0 5px;
      cursor: pointer;
    }
    .have-more i {
      font-size: 12px;
      margin-left: 3px;
    }
  }
  .type-list-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 25px;
    padding: 7px 0 0;
    .type-item {
      cursor: pointer;
      display: inline-block;
      font-weight: 400;
      font-size: 18px;
      color: #515350;
      line-height: 25px;
      padding: 10px;
      margin-right: 22px;
    }
    .is-active {
      position: relative;
      font-weight: 600;
      color: #0d1400;
      &::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        display: block;
        content: "";
        width: 19px;
        height: 4px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 3px;
      }
    }
    .el-dropdown-link {
      font-size: 18px;
      color: #747573;
      line-height: 25px;
    }
  }
}

.h5-org-course-list {
  .have-dropdown.scroll-content {
    width: calc(100% - 1.33rem);
  }
  .scroll-content {
    width: 100%;
    scrollbar-width: 0;
    /* 标准语法，Firefox 支持 */
    -ms-overflow-style: none;
    /* IE 和 Edge */
    &::-webkit-scrollbar {
      display: none;
      /* WebKit 内核浏览器 */
    }
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-behavior: smooth;
  }
  .type-list {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    width: max-content;
  }
  .content-wrap > div:last-child {
    margin-bottom: 0;
  }
  .double-column {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    & > div:nth-last-child(2) {
      margin-bottom: 0;
    }
  }
  .show-more {
    margin-top: 0.21rem;
    width: 100%;
    display: flex;
    justify-content: center;
    color: #515350;
    font-weight: 400;
    font-size: 0.32rem;
    line-height: 0.44rem;
    .have-more {
      color: #00c89d;
      padding: 0 5px;
      cursor: pointer;
    }
    .have-more i {
      font-size: 0.29rem;
      margin-left: 0.08rem;
    }
  }
  .type-list-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.15rem;
    .type-item {
      display: inline-block;
      font-weight: 400;
      font-size: 0.37rem;
      color: #515350;
      line-height: 0.53rem;
      padding: 0.13rem;
      margin-right: 0.27rem;
    }
    .is-active {
      position: relative;
      font-weight: 500;
      color: #0d1400;
      &::after {
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        display: block;
        content: "";
        width: 0.27rem;
        height: 0.05rem;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 0.07rem;
      }
    }
    .el-dropdown-link {
      font-size: 0.37rem;
      color: #747573;
      line-height: 0.53rem;
    }
  }
}
</style>
